import { render, staticRenderFns } from "./dividas.vue?vue&type=template&id=1af5a135"
import script from "./dividas.vue?vue&type=script&lang=js"
export * from "./dividas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports